<script setup>
import { onMounted, ref, watch } from 'vue';

import { useDestinationStore } from '../../../../store/destinationStore';
import { useOrderStore } from '../../../../store/orderStore';
import { useDeviceStore } from '../../../../store/deviceStore';
import { usePeriodStore } from '../../../../store/periodStore';
import { usePlanStore } from '../../../../store/planStore';

import SwitchInput from '../../../../components/ui/inputs/SwitchInput.vue';

const destinationStore = useDestinationStore();
const orderStore = useOrderStore();
const deviceStore = useDeviceStore();
const periodStore = usePeriodStore();
const planStore = usePlanStore();

const quantity = ref(1);
const isMultiDestination = ref(false);

watch(isMultiDestination, (newVal, oldVal) => {
    if (!newVal) {
        quantity.value = 1;

        destinationStore.setSelectedDestination({ destinations: [destinationStore.selectedDestinations[0]] });
        periodStore.setPeriods({ periods: [ { startDate: new Date(), endDate: null } ] });
        planStore.setPlans({ plans: [ {} ] });
    } else if (newVal && quantity.value === 1) {
        planStore.setPlanType({type: 'day'});
        handleQuantity('plus');
    }

    destinationStore.isMultiDestinationEnabled = newVal;
});

function handleQuantity(type) {
    if (type === 'plus') {
        quantity.value += 1;

        periodStore.pushPeriod({period: { startDate: null, endDate: null }});
        planStore.pushPlan({plan: {}});
        destinationStore.pushSelectedDestination({ destination: {} });

    } else if (type === 'minus' && quantity.value > 1) {
        quantity.value -= 1;

        periodStore.popPeriod();
        planStore.popPlan();

        destinationStore.popSelectedDestination();
    }
}

onMounted(() => {
    isMultiDestination.value = destinationStore.isMultiDestinationEnabled;
    quantity.value = destinationStore.selectedDestinations.length;
});
</script>

<template>
    <div class="mb-4 flex justify-between items-center h-14">
        <SwitchInput placeholder="Multi Destination" v-model="isMultiDestination" />

        <div v-if="isMultiDestination" class="flex items-center">
            <h4 class="mr-2">Destinations</h4>

            <div class="bg-white h-10 rounded-md border-2 border-orange-400 flex items-center">
                <div class="cursor-pointer mr-2 pl-1" @click="handleQuantity('minus')">
                    <svg xmlns="http://www.w3.org/2000/svg" height="26px" viewBox="0 -960 960 960" width="26px"
                        fill="#FF8818">
                        <path d="M200-440v-80h560v80H200Z" />
                    </svg>
                </div>
                <div class="text-orange-500 text-xl font-medium select-none">
                    {{ quantity }}
                </div>
                <div class="cursor-pointer ml-2 pr-1" @click="handleQuantity('plus')">
                    <svg xmlns="http://www.w3.org/2000/svg" height="26px" viewBox="0 -960 960 960" width="26px"
                        fill="#FF8818">
                        <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss"></style>